// extracted by mini-css-extract-plugin
export default {"root":"PageDashboard_root__RCTHd"};